import { render, staticRenderFns } from "./ViberDetail.vue?vue&type=template&id=515fbe54&"
import script from "./ViberDetail.vue?vue&type=script&lang=ts&"
export * from "./ViberDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports